import { fork } from 'redux-saga/effects'

import dashboardSaga from '../../containers/Dashboard/saga'

import baseDataSaga from './baseData.saga'
import userSaga from './user.saga'
import alertsSaga from './alerts.saga'
import sdManagerSaga from './sdManager.saga'
import locationManagerSaga from './locationManager.saga'

// All sagas to be loaded
// @ref: https://github.com/mxstbr/react-boilerplate/issues/537
// exporting array of individual sagas doesn't work
// middleware run only accepts one saga
export default function* globalSagas() {
  yield fork(baseDataSaga)
  yield fork(userSaga)
  yield fork(alertsSaga)
  yield fork(dashboardSaga)
  yield fork(locationManagerSaga)
  yield fork(sdManagerSaga)
}
